export type MaterialKind = 'RAW' | 'AUX'

export type MaterialStatus = 'active' | 'inactive'

/** Production-shaped material (UI). */
export type Material = {
  id: string
  code: string
  name: string
  kind: MaterialKind
  status: MaterialStatus
  uom_default?: string
  notes?: string
  group_code?: string | null
  attributes?: Record<string, any>
  created_by?: string
  updated_by?: string
  version: number
  created_at: string
  updated_at: string
}

export type MaterialInput = {
  code: string
  name: string
  kind: MaterialKind
  status: MaterialStatus
  uom_default?: string
  notes?: string
  group_code?: string | null
  attributes?: Record<string, any>
}

export const MATERIAL_STATUS_LABEL: Record<MaterialStatus, string> = {
  active: 'Đang dùng',
  inactive: 'Ngừng dùng',
}

export const MATERIAL_KIND_LABEL: Record<MaterialKind, string> = {
  RAW: 'Nguyên liệu thô',
  AUX: 'Vật tư phụ',
}
